/** Shared brand copy — Kerala traditional Chenda Melam specialists */
export const KERALA_CHENDA_MELAM_FOR_WEDDING = "Kerala Chenda Melam for wedding";

export const BRAND_TAGLINE = "Kerala Style Traditional Chenda Melam Specialists";

export const BRAND_HERO_SUBTITLE =
  `Authentic ${KERALA_CHENDA_MELAM_FOR_WEDDING} and percussion classes — based in Chennai, serving families across South India.`;

export const BRAND_PITCH =
  "We are specialists in Kerala style traditional Chenda Melam — from Thrissur Pooram–inspired wedding ensembles to Panchari Melam, Panchavadyam, and gurukul-trained percussion education.";

export const BRAND_SPECIALTIES = [
  { label: "Kerala Style Traditional", icon: "🪔" },
  { label: "Chenda Melam Specialists", icon: "🥁" },
  { label: "Chenda Melam for Wedding", icon: "💛" },
  { label: "Temple & Panchavadyam", icon: "🏛️" },
  { label: "Marar Lineage Artists", icon: "✨" },
];

export const BRAND_HIGHLIGHTS = [
  {
    title: "Kerala Style Traditional",
    text: "Authentic rhythms, costumes, and repertoire rooted in Kerala temple and wedding traditions — not generic percussion.",
  },
  {
    title: "Chenda Melam Specialists",
    text: "Dedicated Chenda Melam artists trained in Veekku, Chaapu, Panchari, Pandi, and wedding-entry ensembles.",
  },
  {
    title: "Wedding & Event Experts",
    text: "Specialists in groom entry, baraat, reception, and muhurtham — tailored team sizes for every venue.",
  },
  {
    title: "Gurukul-Trained Masters",
    text: "Led by Thiruvambady Vineesh Maarar — Idakka specialist with 30+ years in Kerala percussion arts.",
  },
];
